// extracted by mini-css-extract-plugin
export default {"container":"QX-z","title":"RX-z","link":"SX-z"};